module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(config.style === 'splitScreen')          additionalClasses.push('splitScreen');\nif(config.style === 'splitScreenTriple')    additionalClasses.push('splitScreenTriple');\nelse if(config.style === 'extendedFilters') additionalClasses.push('extendedFilters');\nelse if(config.style === 'squared')         additionalClasses.push('squared');\nif(config.mode) additionalClasses.push(`mode_${config.mode}`);\nvar tooltips = config.tooltips || {};\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<%\nvar additionalClasses = [];\nif(config.style === 'splitScreen' || config.style === 'splitScreenTriple'){\n%>\n<section class=\"splitScreenLeft\">\n<%- helpers.renderSection('filter'); %>\n<%\nif(tooltips.NW){\n%><%- include('../tooltip/tooltip', { model: tooltips.NW, config: { additionalClasses: 'NW' } }); %><%\n}\nif(tooltips.N){\n%><%- include('../tooltip/tooltip', { model: tooltips.N, config: { additionalClasses: 'N' } }); %><%\n}\nif(tooltips.NE){\n%><%- include('../tooltip/tooltip', { model: tooltips.NE, config: { additionalClasses: 'NE' }  }); %><%\n}\n%>\n<section class=\"filterContent\">\n<section class=\"colWrap\">\n<%- helpers.renderSection('treeContainer'); %>\n</section>\n</section>\n</section>\n<section class=\"splitScreenRight\">\n<%- helpers.renderSection('properties'); %>\n<%- helpers.renderSection('actions'); %>\n</section>\n<%\n} else if(config.style === 'extendedFilters') {\n%>\n<%- helpers.renderSection('header'); %>\n<%\n// TODO: POI?!?!??!\nif(tooltips.NW){\n%><%#- include('../tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"content\">\n<%- helpers.renderSection('filter'); %>\n<%- helpers.renderSection('treeContainer'); %>\n<%- helpers.renderSection('actions'); %>\n</section>\n<%\n} else if(config.style === 'squared') {\n%>\n<%- helpers.renderSection('filter'); %>\n<%\nif(tooltips.NW){\n%><%- include('../tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"filterContent horizontal\">\n<section class=\"colWrap vertical\">\n<%- helpers.renderSection('treeContainer'); %>\n<%- helpers.renderSection('properties'); %>\n</section>\n<%- helpers.renderSection('actions'); %>\n</section>\n<%\n} else {\n%>\n<%- helpers.renderSection('filter'); %>\n<%\nif(tooltips.NW){\n%><%- include('../tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"filterContent\">\n<section class=\"colWrap\">\n<%- helpers.renderSection('treeContainer'); %>\n<%- helpers.renderSection('properties'); %>\n<%- helpers.renderSection('actions'); %>\n</section>\n</section>\n<%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/trees/trees.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(config.style === 'splitScreen')          additionalClasses.push('splitScreen');
if(config.style === 'splitScreenTriple')    additionalClasses.push('splitScreenTriple');
else if(config.style === 'extendedFilters') additionalClasses.push('extendedFilters');
else if(config.style === 'squared')         additionalClasses.push('squared');
if(config.mode) additionalClasses.push(`mode_${config.mode}`);
var tooltips = config.tooltips || {};

    ; __line = 9
    ; __append("\n<div class=\"")
    ; __line = 10
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n")
    ; __line = 11
    ; 
var additionalClasses = [];
if(config.style === 'splitScreen' || config.style === 'splitScreenTriple'){

    ; __line = 14
    ; __append("\n<section class=\"splitScreenLeft\">\n")
    ; __line = 16
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 17
    ; 
if(tooltips.NW){

    ; __line = 19
    ; __append( include('../tooltip/tooltip', { model: tooltips.NW, config: { additionalClasses: 'NW' } }) )
    ; 
}
if(tooltips.N){

    ; __line = 22
    ; __append( include('../tooltip/tooltip', { model: tooltips.N, config: { additionalClasses: 'N' } }) )
    ; 
}
if(tooltips.NE){

    ; __line = 25
    ; __append( include('../tooltip/tooltip', { model: tooltips.NE, config: { additionalClasses: 'NE' }  }) )
    ; 
}

    ; __line = 27
    ; __append("\n<section class=\"filterContent\">\n<section class=\"colWrap\">\n")
    ; __line = 30
    ; __append( helpers.renderSection('treeContainer') )
    ; __append("\n</section>\n</section>\n</section>\n<section class=\"splitScreenRight\">\n")
    ; __line = 35
    ; __append( helpers.renderSection('properties') )
    ; __append("\n")
    ; __line = 36
    ; __append( helpers.renderSection('actions') )
    ; __append("\n</section>\n")
    ; __line = 38
    ; 
} else if(config.style === 'extendedFilters') {

    ; __line = 40
    ; __append("\n")
    ; __line = 41
    ; __append( helpers.renderSection('header') )
    ; __append("\n")
    ; __line = 42
    ; 
// TODO: POI?!?!??!
if(tooltips.NW){

    ; __line = 45
    ; 
}

    ; __line = 47
    ; __append("\n<section class=\"content\">\n")
    ; __line = 49
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 50
    ; __append( helpers.renderSection('treeContainer') )
    ; __append("\n")
    ; __line = 51
    ; __append( helpers.renderSection('actions') )
    ; __append("\n</section>\n")
    ; __line = 53
    ; 
} else if(config.style === 'squared') {

    ; __line = 55
    ; __append("\n")
    ; __line = 56
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 57
    ; 
if(tooltips.NW){

    ; __line = 59
    ; __append( include('../tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 61
    ; __append("\n<section class=\"filterContent horizontal\">\n<section class=\"colWrap vertical\">\n")
    ; __line = 64
    ; __append( helpers.renderSection('treeContainer') )
    ; __append("\n")
    ; __line = 65
    ; __append( helpers.renderSection('properties') )
    ; __append("\n</section>\n")
    ; __line = 67
    ; __append( helpers.renderSection('actions') )
    ; __append("\n</section>\n")
    ; __line = 69
    ; 
} else {

    ; __line = 71
    ; __append("\n")
    ; __line = 72
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 73
    ; 
if(tooltips.NW){

    ; __line = 75
    ; __append( include('../tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 77
    ; __append("\n<section class=\"filterContent\">\n<section class=\"colWrap\">\n")
    ; __line = 80
    ; __append( helpers.renderSection('treeContainer') )
    ; __append("\n")
    ; __line = 81
    ; __append( helpers.renderSection('properties') )
    ; __append("\n")
    ; __line = 82
    ; __append( helpers.renderSection('actions') )
    ; __append("\n</section>\n</section>\n")
    ; __line = 85
    ; 
}

    ; __line = 87
    ; __append("\n</div>")
    ; __line = 88
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/trees/trees.ejs

}